import { EventWithVenue } from "../../models";
import { EventsOnSaleActions } from "./events-on-sale.actions";
export interface EventsOnSaleState {
	collection: EventWithVenue[],
	search: any,
	order: string
};

const initialState: EventsOnSaleState  = {
	collection: [],
	search: {},
	order: "begin"
}

export const reducerFunction = (state = initialState, action) => {
	switch (action.type) {
		case EventsOnSaleActions.EVENTS_ON_SALE_LOADED:
			return Object.assign({}, state, {collection: action.payload})

		case EventsOnSaleActions.EVENTS_ON_SALE_SEARCH:
			return Object.assign({}, state, {search: action.payload})

		case EventsOnSaleActions.EVENTS_ON_SALE_ORDER:
			return Object.assign({}, state, {order: action.payload})

		default: {
			return state;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/events-on-sale/events-on-sale.reducer.ts